import styled from "@emotion/styled";
import { withShowIf } from "../../../../../../components/with-show-if/with-show-If.component";
import { ProductsTableStatusIndicatorIconProps } from "./products-table-status-indicator-icon.props";

export const ProductsTableStatusIndicatorIcon = withShowIf(styled.span`
  height: 10px;
  width: 10px;
  background-color: ${(props: ProductsTableStatusIndicatorIconProps) => {
    switch (props.status) {
      case "manual":
        return props.theme?.colors.orange2;
      case "system_overwritten":
      case "removed":
        return props.theme?.colors.red;
      case "system_confirmed":
        return props.theme?.colors.treeGreen;
      case "none":
      default:
        return "";
    }
  }};
  border-radius: 50%;
  margin-left: 4px;
  display: inline-block;
  vertical-align: middle;
`);
